
import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";


const fetchCodes = (page, size, search) => {
    return useQuery(
        ["get-all-codes"],
        () =>
            request({
                url: `shortCodeMapping/admin`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                params: search.length > 0 ? {
                    page: page,
                    size: size,
                    type: "UTM_PARAMETERS",
                } : {
                    page: page,
                    size: size,
                    type: "UTM_PARAMETERS",
                },
            })

    );
}



export { fetchCodes };




